import React, { Component } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

const Backdrop = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: #616161c5;
  padding-top: 140px;
  z-index: 1000;
`

const ModalContainer = styled.div`
  background: #fff;
  border-radius: 5px;
  max-width: 250px;
  min-width: 200px;
  width: 70%;
  min-height: 130px;
  margin: 0 auto;
  padding: 20px;
`
const Message = styled.p`
  font-size: 16px;
  text-align: center;
  font-weight: 600;
`
const Placeholder = styled.p`
  font-size: 14px;
  text-align: center;
  padding-top: 5px;
  padding-bottom: 5px;
`
const Flexer = styled.div`
  display: flex;
  flex-direction: row;
`
export const Modal = props => {
  const {
    show,
    message,
    element,
    placeholder,
  } = props

  if (!show) {
    return null
  }
  return (
    <Backdrop>
      <ModalContainer>
        <Message>{message}</Message>
        <Placeholder>{placeholder}</Placeholder>
        <Flexer>{element}</Flexer>
      </ModalContainer>
    </Backdrop>
  )
}

Modal.propTypes = {
  show: PropTypes.bool.isRequired,
  message: PropTypes.any,
  placeholder: PropTypes.any,
  element: PropTypes.any,
}
export default Modal



// WEBPACK FOOTER //
// ./src/components/modal.js